export const generateArrOfNumbers = (entries: number, startsFrom?: number) => {
  const arr = [];

  for (let i = startsFrom ?? 1; i <= entries; i++) {
    arr.push(i);
  }

  return arr;
};
